export default "__VITE_ASSET__PVOAFVql__"